import React from "react";
import PoweredByImage from "../../../../assets/img/newPwdBy.png";
import ReportImage from "../ReportImage";
import { buildActionPlanItems } from "../../model/actionPlanItems";
import { dateOrDash, getPriority } from "../../utils/reportHelpers";

const ROWS_FIRST = 5;
const ROWS_SUBSEQUENT = 6;

const ActionPlanPage = React.memo(function ActionPlanPage({
  reportData,
  pageNum,
  propLogo,
  actionPlanPageIndex = 0,
}) {
  const actionItems = buildActionPlanItems(reportData);
  const totalRows = actionItems.length;
  const remainingRows = Math.max(0, totalRows - ROWS_FIRST);
  const totalPages =
    totalRows === 0
      ? 0
      : 1 +
        (remainingRows > 0
          ? Math.ceil(remainingRows / ROWS_SUBSEQUENT)
          : 0);

  const currentRowsPerPage =
    actionPlanPageIndex === 0 ? ROWS_FIRST : ROWS_SUBSEQUENT;
  const startindex =
    actionPlanPageIndex === 0
      ? 0
      : ROWS_FIRST + (actionPlanPageIndex - 1) * ROWS_SUBSEQUENT;
  const endIndex = Math.min(startindex + currentRowsPerPage, totalRows);
  const pageItems = actionItems.slice(startindex, endIndex);
  const isLastPage = actionPlanPageIndex === totalPages - 1;

  if (!pageItems.length) return null;

  return (
    <div className="action-plan-wrapper">
      <div
        className={
          isLastPage ? "page-container last-page" : "page-container"
        }
      >
        {actionPlanPageIndex === 0 && (
          <>
            <h1 className="page-title">Action Plan</h1>
            <div className="hdrRule" />
          </>
        )}
        <table className="action-table">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Priority</th>
              <th>Action Required</th>
              <th>Element Affected</th>
              <th>Due Date</th>
              <th>Assigned To</th>
              <th>Completed On</th>
              <th>Completed By</th>
            </tr>
          </thead>
          <tbody>
            {pageItems.map((item) => {
              const door = item.door;
              const priority = getPriority(item.severity);
              const priorityClass = `priority-${priority.toLowerCase()}`;
              const elementText = `Communal Fire Door ${door.doorRefNumber} (Floor: ${door.floorNo ?? "N/A"} main house. Location: ${door.doorLocation ?? "N/A"})`;
              return (
                <tr
                  key={`${door.inspectedDoorId}-${item.title}-${item.actionRequired?.slice(0, 20)}`}
                >
                  <td>{door.doorRefNumber}</td>
                  <td>
                    <span className={`priority-pill ${priorityClass}`}>
                      {priority}
                    </span>
                  </td>
                  <td className="action-required">{item.actionRequired}</td>
                  <td className="element-affected">{elementText}</td>
                  <td>{dateOrDash(item.dueDate)}</td>
                  <td>{item.assignedTo ?? "-"}</td>
                  <td>{dateOrDash(item.completedOn)}</td>
                  <td>{item.completedBy ?? "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="action-plan-footer">
          <div className="footer-logo-left">
            {propLogo && (
              <ReportImage
                src={`data:image/png;base64,${propLogo}`}
                alt="Client logo"
              />
            )}
          </div>
          <div className="footer-page-number action-plan-page-number">
            Page No. {pageNum}
          </div>
          <div className="footer-logo-right">
            <ReportImage src={PoweredByImage} alt="Powered by" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default ActionPlanPage;
